import { sparql } from '@tpluscode/rdf-string';
import { assertWellFormedPath, fromNode, PathVisitor } from './path.js';
class ToSparqlPropertyPath extends PathVisitor {
    visitSequencePath({ paths }, { isRoot = true } = {}) {
        const sequence = paths.reduce(this.pathChain('/'), sparql ``);
        if (isRoot) {
            return sequence;
        }
        return sparql `(${sequence})`;
    }
    visitInversePath({ path: inversed }) {
        return sparql `^${inversed.accept(this, { isRoot: false })}`;
    }
    visitAlternativePath({ paths }, { isRoot = true } = {}) {
        const alternative = paths.reduce(this.pathChain('|'), sparql ``);
        if (isRoot) {
            return alternative;
        }
        return sparql `(${alternative})`;
    }
    visitZeroOrMorePath({ path: inner }) {
        return sparql `${inner.accept(this, { isRoot: false })}*`;
    }
    visitOneOrMorePath({ path: inner }) {
        return sparql `${inner.accept(this, { isRoot: false })}+`;
    }
    visitZeroOrOnePath({ path: inner }) {
        return sparql `${inner.accept(this, { isRoot: false })}?`;
    }
    visitPredicatePath({ term: predicate }) {
        return sparql `${predicate}`;
    }
    pathChain(operator) {
        return (previous, current, index) => {
            if (index === 0) {
                return current.accept(this, { isRoot: false });
            }
            return sparql `${previous}${operator}${current.accept(this, { isRoot: false })}`;
        };
    }
}
/**
 * Creates a SPARQL template string which represents a SHACL path as Property Path
 *
 * @param path SHACL Property Path
 */
export function toSparql(path) {
    const visitor = new ToSparqlPropertyPath();
    return visitor.visit(fromNode(path));
}
/**
 * Splits a Sequence Path and returns an array of SPARQL template results.
 * If the path is not a Sequence Path, returns an array with a single element
 *
 * @param path SHACL Property Path
 */
toSparql.sequence = (path) => {
    assertWellFormedPath(path);
    const list = path.list();
    if (list) {
        return [...list].map(el => toSparql(el));
    }
    return [toSparql(path)];
};
//# sourceMappingURL=toSparql.js.map